import { loggerFactory } from './logger';

const TIMER_PREFIX = `timerFor`;
const logger = loggerFactory(`PersistentTimers`);

/**
 * Function to provide a mechanism to run timeout functions with support
 * for page reloads.
 * @param callback - the function to execute
 * @param delay - the set time (in milliseconds) to run the function
 * @param optName - a name to use for the timer.  In the case that the callback does
 *  not have a name property, this must be supplied.
 * @returns
 */
export const setPersistentTimeout = (callback, delay, optName?: string) => {
  const callbackName = optName ? optName : callback.name ?? false;
  if (!callbackName) {
    logger.error(`no callback name found, unable to set persistent timer`);
    throw new Error(`unable to set persistent timer`);
  } else {
    const d = new Date();
    const targetTime = d.getTime() + delay;
    const targetDate = new Date(targetTime);

    // each page can have their own timers.
    sessionStorage.setItem(`${TIMER_PREFIX}_${callbackName}`, targetTime);
    logger.debug(
      `Set timeout for ${callbackName}: ${targetTime} (${targetDate.toISOString()})`
    );
    return (setTimeout(callback, delay) as any) as number;
  }
};

/**
 * Function to provide a timeout value for a registered persistent timer.
 * @param callbackName - the name of the timer to check for presence.
 * @returns
 */
export const checkPersistentTimeout = (callbackName?: string) => {
  const cbKey = `${TIMER_PREFIX}_${callbackName}`;
  const cbValue = sessionStorage.getItem(cbKey);
  if (!cbValue) {
    logger.debug(
      `no persistent timer found for ${callbackName} - using cbKey ${cbKey}`
    );
  } else {
    const targetTime = parseInt(cbValue, 10);

    const currentTime = new Date().getTime();
    const timeDelta = targetTime - currentTime;

    logger.debug(
      `Target time for ${callbackName}: ${targetTime} (target) - ${currentTime} (current) = ${timeDelta /
        1000}s`
    );

    if (targetTime && timeDelta > 0) {
      return timeDelta;
    }
  }
  return null;
};

/**
 * Remove any persistence for page reload timers.
 * @param callbackName - The name of the function.
 */
export const clearPersistentTimeout = callbackName => {
  sessionStorage.removeItem(`${TIMER_PREFIX}_${callbackName}`);
};
